import { baseConfig } from "config";
import { getAccessToken } from "services/auth";
import { MessageType } from "store/features/registration/types";
import { MessageSourceType } from "utils/enum";
import { Requester } from "./requester";

export const getMessages = async (trip_request_id: string | null = "") => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/trip-request/${trip_request_id}/message/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result): MessageResponse[] => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export interface MessageResponse {
	id: string;
}

export const createMessage = async (
	trip_request_id: string | null,
	message: MessageType
) => {
	const access_token = await getAccessToken();

	const requestData = { ...message, message_source: MessageSourceType.PARTNER };

	return Requester.post({
		url: `${baseConfig.baseURL}/trip-request/${trip_request_id}/message/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		body: requestData,
		success: (result): MessageResponse => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};
